// extracted by mini-css-extract-plugin
export default {"detailContainer":"detailContainer-vCuNm","detailContainerInner":"detailContainerInner-Xtl5S","testName":"testName-QaEb2","flexRow":"flexRow-VVzVK","testsRow":"testsRow-qAXRN"};